import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import {
  ArrowLeft,
  Plus,
  Trash2,
  Save,
  Search,
  Package,
  X,
  Minus,
  Tag,
  Warehouse,
  Mail,
  Image,
  Check,
  Send,
  Download,
  Share2,
  User,
  FileText,
  Printer,
  ChevronRight,
  ChevronLeft,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// const WAREHOUSES = [
//   { key: "santiago", name: "Almacén Santiago", color: "bg-blue-500" },
//   { key: "santo_domingo", name: "Almacén Santo Domingo", color: "bg-emerald-500" },
//   { key: "cerro_alto", name: "Almacén Cerro Alto", color: "bg-amber-500" },
//   { key: "bella_vista", name: "Almacén Bella Vista", color: "bg-purple-500" },
// ];

const PRICE_TYPES = {
  retail: { label: "Consumo", key: "price", color: "bg-blue-100 text-blue-700" },
  wholesale: { label: "Mayor", key: "price_wholesale", color: "bg-emerald-100 text-emerald-700" },
  fleet: { label: "Flotilla", key: "price_fleet", color: "bg-purple-100 text-purple-700" },
};

const DocumentEditorPage = () => {
  const { docId } = useParams();
  const [searchParams] = useSearchParams();
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [saved, setSaved] = useState(false);

  const isEdit = saved ? false : searchParams.get("edit") === "true" || !docId;
  const preselectedClient = searchParams.get("client");
  const preselectedType = searchParams.get("type") || "order";
  const preciotype = searchParams.get("preciotype") || "retail";


  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [clients, setClients] = useState({});
  const [articles, setArticles] = useState({
    rows: [],
    page: 1,
    totalRow: 0,
    totalPages: 0
  });
  const [showArticleModal, setShowArticleModal] = useState(false);
  const [articleSearch, setArticleSearch] = useState("");

  const [WAREHOUSES, setWAREHOUSES] = useState([])

  const [formData, setFormData] = useState({
    client_id: preselectedClient || "",
    doc_type: preselectedType,
    items: [],
    comments: "",
    status: "pending",
    priceType: preciotype
  });

  const [docInfo, setDocInfo] = useState(null);
  const [showPostSaveModal, setShowPostSaveModal] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState("");
  const documentRef = useRef(null);

  //Terminos de Consultas
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentSucursal, setCurrentSucursal] = useState(-1);
  const [currentEstado, setCurrentEstado] = useState(1);


  useEffect(() => {
    fetchInitialData();
    fetchArticle();
  }, [docId]);

  const fetchInitialData = async () => {
    try {
      const [clientsRes, articleswareHousesRes] = await Promise.all([
        axios.get(`${API}/clients/${preselectedClient}`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/articles/warehouses`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setClients(clientsRes.data);
      setWAREHOUSES(articleswareHousesRes.data)



      if (docId) {
        const docRes = await axios.get(`${API}/documents/${docId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDocInfo(docRes.data);

        const allowed = ["retail", "wholesale", "fleet"];
        const priceType = allowed.includes(docRes.data.priceType)
          ? docRes.data.priceType
          : "retail";

        setFormData({
          ...formData,
          client_id: docRes.data.client_id,
          doc_type: docRes.data.doc_type,
          items: docRes.data.items,
          comments: docRes.data.comments || "",
          status: docRes.data.status,
          priceType
        });
      }
    } catch (error) {
      toast.error("Error al cargar datos");
    } finally {
      setLoading(false);
    }
  };


  const searchTermfilter = articleSearch.trim();

  const fetchArticle = async () => {
    try {

      const response = await axios.get(`${API}/articles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          search: searchTermfilter,
          page: currentPage,
          cantidadRow: rowsPerPage,
          sucursal: currentSucursal,
          estado: currentEstado
        }
      });
      setArticles(response.data);
    } catch (error) {
      console.log(error)
      toast.error("Error al cargar Articulos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticle();
    //eslint-disable-next-line
  }, [searchTermfilter, rowsPerPage, currentPage, currentSucursal, currentEstado]);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const getArticlePrice = (article) => {
    const priceKey = PRICE_TYPES[formData.priceType].key;
    return article[priceKey] || article.price;
  };

  const handleAddArticle = (article) => {
    const existingIndex = formData.items.findIndex(
      (item) => item.article_id === article.id
    );

    const price = getArticlePrice(article);

    if (existingIndex >= 0) {
      const newItems = [...formData.items];
      newItems[existingIndex].quantity += 1;
      newItems[existingIndex].total =
        newItems[existingIndex].quantity * newItems[existingIndex].unit_price;
      setFormData({ ...formData, items: newItems });
      toast.success(`Cantidad actualizada: ${newItems[existingIndex].quantity}`);
    } else {
      const newItem = {
        article_id: article.id,
        article_code: article.code,
        article_name: article.name,
        impuesto: article.impuesto,
        quantity: 1,
        unit_price: price,
        total: price,
      };

      setFormData({
        ...formData,
        items: [...formData.items, newItem],
      });
      toast.success("Artículo agregado");
    }
  };

  const handleUpdateQuantity = (index, newQuantity) => {
    if (newQuantity < 1) return;
    const newItems = [...formData.items];
    newItems[index].quantity = newQuantity;
    newItems[index].total = newQuantity * newItems[index].unit_price;
    setFormData({ ...formData, items: newItems });
  };

  const handleUpdatePrice = (index, newPrice) => {
    const newItems = [...formData.items];
    newItems[index].unit_price = newPrice;
    newItems[index].total = newItems[index].quantity * newPrice;
    setFormData({ ...formData, items: newItems });
  };

  const handleRemoveItem = (index) => {
    const newItems = formData.items.filter((_, i) => i !== index);
    setFormData({ ...formData, items: newItems });
    toast.success("Artículo eliminado");
  };

  const handleSave = async () => {
    if (!formData.client_id) {
      toast.error("Selecciona un cliente");
      return;
    }
    if (formData.items.length === 0) {
      toast.error("Agrega al menos un artículo");
      return;
    }

    setSaving(true);
    try {
      if (docId) {
        await axios.put(`${API}/documents/${docId}`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Documento actualizado");
        // Set client email from docInfo or client list
        if (clients?.email) {
          setRecipientEmail(clients.email);
        }
        setShowPostSaveModal(true);
        setSaved(true)
        NotificarEmpresa()
      } else {
        const response = await axios.post(`${API}/documents`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Documento creado");
        // Set client email from response (includes client_email now)
        if (response.data.client_email) {
          setRecipientEmail(response.data.client_email);
        } else {
          if (clients?.email) {
            setRecipientEmail(clients.email);
          }
        }
        setDocInfo(response.data);
        setShowPostSaveModal(true);
        // Update URL without full navigation
        window.history.replaceState(null, '', `/document/${response.data.id}`);
      }
    } catch (error) {
      toast.error("Error al guardar documento");
    } finally {
      setSaving(false);
    }
  };

  const handleSendEmail = async () => {
    if (!recipientEmail) {
      toast.error("Ingresa un correo electrónico");
      return;
    }


    toast.loading("Generando PDF...");
    const canvas = await generateDocumentImage();

    if (!canvas) {
      toast.dismiss();
      toast.error("Error al generar PDF");
      return;
    }


    const imgData = canvas.toDataURL('image/png');
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    // Calculate PDF dimensions (A4 paper)
    const pdfWidth = 210; // A4 width in mm
    const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

    const pdf = new jsPDF({
      orientation: pdfHeight > pdfWidth ? 'portrait' : 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    // Add the image to PDF
    const pageHeight = 297; // A4 height in mm
    let heightLeft = pdfHeight;
    let position = 0;

    // First page
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;

    // Add more pages if content is too long
    while (heightLeft > 0) {
      position = heightLeft - pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;
    }

    const base64Pdf = pdf.output("datauristring").split(',')[1];

    toast.dismiss();
    toast.success("PDF descargado");


    setSendingEmail(true);
    try {
      await axios.post(`${API}/send-email`, {
        recipient_email: recipientEmail,
        subject: `${docTypeLabels[formData.doc_type]} #${docInfo?.doc_number || 'Nuevo'} - ${user.company_name}`,
        base64Pdf: base64Pdf,
        documento: `${docTypeLabels[formData.doc_type]} #${docInfo?.doc_number || 'Nuevo'}`
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(`Correo enviado a ${recipientEmail}`);
      setEmailSent(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al enviar correo");
    } finally {
      setSendingEmail(false);
    }
  };

  const NotificarEmpresa = async () => {

    const canvas = await generateDocumentImage();

    if (!canvas) {
      toast.dismiss();
      toast.error("Error al generar PDF");
      return;
    }


    const imgData = canvas.toDataURL('image/png');
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    // Calculate PDF dimensions (A4 paper)
    const pdfWidth = 210; // A4 width in mm
    const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

    const pdf = new jsPDF({
      orientation: pdfHeight > pdfWidth ? 'portrait' : 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    // Add the image to PDF
    const pageHeight = 297; // A4 height in mm
    let heightLeft = pdfHeight;
    let position = 0;

    // First page
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;

    // Add more pages if content is too long
    while (heightLeft > 0) {
      position = heightLeft - pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;
    }

    const base64Pdf = pdf.output("datauristring").split(',')[1];

    toast.dismiss();


    setSendingEmail(true);
    try {
      await axios.post(`${API}/send-email`, {
        recipient_email: 'main',
        subject: `${docTypeLabels[formData.doc_type]} #${docInfo?.doc_number || 'Nuevo'} `,
        base64Pdf: base64Pdf,
        documento: `${docTypeLabels[formData.doc_type]} #${docInfo?.doc_number || 'Nuevo'}`
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al enviar Notificacion");
    } finally {
      setSendingEmail(false);
    }
  };

  const generateDocumentImage = async () => {
    if (!documentRef.current) return null;

    try {
      const canvas = await html2canvas(documentRef.current, {
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false,
        useCORS: true,
      });
      return canvas;
    } catch (error) {
      console.error("Error generating image:", error);
      return null;
    }
  };

  const handleSaveAsImage = async () => {
    toast.loading("Generando imagen...");
    const canvas = await generateDocumentImage();

    if (!canvas) {
      toast.dismiss();
      toast.error("Error al generar imagen");
      return;
    }

    const link = document.createElement('a');
    link.download = `${docTypeLabels[formData.doc_type]}_${docInfo?.doc_number || 'nuevo'}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();

    toast.dismiss();
    toast.success("Imagen descargada");
  };

  const handleSaveAsPDF = async () => {
    toast.loading("Generando PDF...");
    const canvas = await generateDocumentImage();

    if (!canvas) {
      toast.dismiss();
      toast.error("Error al generar PDF");
      return;
    }

    try {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Calculate PDF dimensions (A4 paper)
      const pdfWidth = 210; // A4 width in mm
      const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

      const pdf = new jsPDF({
        orientation: pdfHeight > pdfWidth ? 'portrait' : 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      // Add the image to PDF
      const pageHeight = 297; // A4 height in mm
      let heightLeft = pdfHeight;
      let position = 0;

      // First page
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;

      // Add more pages if content is too long
      while (heightLeft > 0) {
        position = heightLeft - pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${docTypeLabels[formData.doc_type]}_${docInfo?.doc_number || 'nuevo'}.pdf`);

      toast.dismiss();
      toast.success("PDF descargado");
    } catch (error) {
      toast.dismiss();
      toast.error("Error al generar PDF");
      console.error("PDF Error:", error);
    }
  };

  const handlePrintPOS = () => {
    // Formatear número con separadores de miles
    const formatNumber = (num) => {
      return num?.toLocaleString("es-DO", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) || "0.00";
    };

    // Formatear fecha DD-MM-YYYY
    const formatDate = (dateStr) => {
      if (!dateStr) return new Date().toLocaleDateString("es-DO");
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Mapear tipo de documento
    const docTypeMap = {
      order: "PEDIDO",
      quote: "COTIZACION",
      invoice: "FACTURA"
    };

    // Construir JSON para PrintPOS
    const printPOSData = {
      empresa: user.company_name,
      logo: user.company_logo && user.company_logo.includes(',')
        ? user.company_logo.split(',')[1]
        : (user.company_logo || null),
      atendido: (docInfo?.user_name || user?.name || "N/A").toUpperCase(),
      documento: {
        tipo: docTypeMap[formData.doc_type] || "PEDIDO",
        numero: docInfo?.doc_number || "NUEVO",
        fecha: formatDate(docInfo?.created_at),
        cliente: (selectedClient?.name || "N/A").toUpperCase(),
        rnc: selectedClient?.rnc || "N/A"
      },
      items: formData.items.map(item => ({
        codigo: item.article_code?.toUpperCase() || "N/A",
        cantidad: item.quantity,
        precio: formatNumber(parseFloat(item.unit_price)),
        total: formatNumber(parseFloat(item.total)),
        nombre: item.article_name?.toUpperCase() || "N/A"
      })),
      sumary: {
        subtotal: formatNumber(subtotal),
        impuesto: formatNumber(tax),
        total: formatNumber(total)
      }
    };


    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'print',
        format: 'pedido', // Identificador para que la app sepa qué plantilla usar
        datos: printPOSData
      }));
      toast.success("Datos enviados a PrintPOS.");
      return; // No abrir ventana nueva
    } else {
      console.log(printPOSData)
      toast.error("Datos no se pudo enviar a PrintPOS.");
    }


  };

  const formatNumeric = (amount) =>
    `${parseFloat(amount)?.toLocaleString("es-DO", { minimumFractionDigits: 2 })}`;

  const formatCurrency = (amount) =>
    `RD$ ${amount?.toLocaleString("es-DO", { minimumFractionDigits: 2 })}`;

  const total = formData.items.reduce((sum, item) => sum + parseFloat(item.total), 0);
  const tax = formData.items.reduce((sum, item) => {
    const total = parseFloat(item.total) || 0;
    // Convertimos el impuesto a decimal (ej: 16 a 0.16). 
    // Si no existe, usamos 0.
    const tasaImpuesto = (parseFloat(item.impuesto) || 0) / 100;

    // Calculamos el monto del impuesto contenido en el total
    const montoImpuesto = total - (total / (1 + tasaImpuesto));

    return sum + parseFloat(parseFloat(montoImpuesto).toFixed(2))
  }, 0);
  const subtotal = total - tax;

  const docTypeLabels = {
    order: "Pedido",
    quote: "Cotización",
    invoice: "Factura",
  };

  const selectedClient = clients;



  const getCategoryStyle = (category) => {
    const styles = {
      gomas: "bg-blue-100 text-blue-700",
      baterias: "bg-amber-100 text-amber-700",
      aceites: "bg-emerald-100 text-emerald-700",
      accesorios: "bg-purple-100 text-purple-700",
    };
    return styles[category] || "bg-slate-100 text-slate-700";
  };

  const getCategoryLabel = (category) => {
    const labels = {
      gomas: "Gomas",
      baterias: "Baterías",
      aceites: "Aceites",
      accesorios: "Accesorios",
    };
    return labels[category] || category;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }



  return (
    <div className="animate-fade-in max-w-5xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-4 mb-6">
        <Button
          variant="ghost"
          size="icon"
          data-testid="back-btn"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} />
        </Button>
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-slate-800">
            {docId ? (isEdit ? "Editar" : "Ver") : "Nuevo"} {docTypeLabels[formData.doc_type]}
          </h2>
          {docInfo && (
            <p className="text-sm text-slate-500 mono">#{docInfo.doc_number}</p>
          )}
        </div>
        {isEdit ? (
          <Button
            data-testid="save-document-btn"
            onClick={handleSave}
            disabled={saving}
            className="bg-[#0F172A] hover:bg-[#1E293B]"
          >
            <Save size={18} className="mr-2" />
            {saving ? "Guardando..." : "Guardar"}
          </Button>
        ) : (
          <Button
            data-testid="save-document-btn"
            onClick={() => {
              if (clients?.email) {
                setRecipientEmail(clients.email);
              }
              setShowPostSaveModal(true);
            }}
            disabled={saving}
            className="bg-[#0F172A] hover:bg-[#1E293B]"
          >
            <Save size={18} className="mr-2" />
            Imprimir
          </Button>
        )}
      </div>

      {/* Document Paper - Print Format */}
      <div className="document-paper bg-white" ref={documentRef}>
        {/* Document Header */}
        <div className="document-header">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-400 uppercase tracking-wider mb-1"> {user.company_name}</p>
              <h3 className="text-2xl font-bold">
                {docTypeLabels[formData.doc_type]}
              </h3>
              {docInfo && (
                <p className="text-slate-300 mono text-lg">#{docInfo.doc_number}</p>
              )}
            </div>
            <div className="text-right">
              <p className="text-sm text-slate-300">Fecha</p>
              <p className="font-medium text-lg">
                {docInfo
                  ? docInfo.created_at?.slice(0, 10)
                  : new Date().toISOString().slice(0, 10)}
              </p>
            </div>
          </div>
        </div>

        {/* Document Body */}
        <div className="document-body">
          {/* Client & Type Selection */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="space-y-2">
              <Label>Cliente </Label>

              <p className="text-slate-800 font-medium">
                {selectedClient?.name || "-"}
              </p>

              {selectedClient && (
                <div className="text-sm text-slate-500 space-y-1 mt-2 bg-slate-50 p-2 rounded">
                  {selectedClient.rnc && <p><strong>RNC:</strong> {selectedClient.rnc}</p>}
                  {selectedClient.phone && <p><strong>Tel:</strong> {selectedClient.phone}</p>}
                  {selectedClient.address && <p><strong>Dir:</strong> {selectedClient.address}</p>}
                </div>
              )}
            </div>

            <div className="space-y-2">
              <Label>Tipo de Documento</Label>

              {isEdit && !docId ? (
                <Select
                  value={formData.doc_type}
                  onValueChange={(value) =>
                    setFormData({ ...formData, doc_type: value })
                  }
                >
                  <SelectTrigger data-testid="doctype-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="order">Pedido</SelectItem>
                    <SelectItem value="quote">Cotización</SelectItem>
                  </SelectContent>
                </Select>
              ) : (
                <p className="text-slate-800 font-medium">
                  {docTypeLabels[formData.doc_type]}
                </p>
              )}

              <div className="mt-4">
                <Label>Estado</Label>
                {isEdit ? (
                  <Select
                    value={formData.status}
                    onValueChange={(value) =>
                      setFormData({ ...formData, status: value })
                    }
                  >
                    <SelectTrigger data-testid="status-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="pending">Pendiente</SelectItem>
                      <SelectItem value="approved">Aprobado</SelectItem>
                      <SelectItem value="completed">Completado</SelectItem>
                      <SelectItem value="cancelled">Cancelado</SelectItem>
                    </SelectContent>
                  </Select>
                ) : (
                  <p className="text-slate-800">{formData.status}</p>
                )}
              </div>
            </div>

            {/* Price Type Selector */}
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Tag size={16} />
                Tipo de Precio
              </Label>


              {/* Price type badge */}
              <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${PRICE_TYPES[formData.priceType].color}`}>
                <Tag size={14} />
                Precio: {PRICE_TYPES[formData.priceType].label}
              </div>
            </div>
          </div>

          {/* Items Table */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-3">
              <Label className="text-base">Artículos</Label>
              {isEdit && (
                <Button
                  data-testid="add-article-btn"
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setArticleSearch("");
                    setShowArticleModal(true);
                  }}
                >
                  <Plus size={16} className="mr-1" />
                  Buscar Artículo
                </Button>
              )}
            </div>

            {formData.items.length === 0 ? (
              <div className="border border-dashed border-slate-300 rounded p-8 text-center">
                <Package size={32} className="mx-auto text-slate-400 mb-2" />
                <p className="text-slate-500">No hay artículos</p>
                {isEdit && (
                  <Button
                    data-testid="add-first-article-btn"
                    variant="link"
                    className="mt-2"
                    onClick={() => {
                      setArticleSearch("");
                      setShowArticleModal(true);
                    }}
                  >
                    Buscar y agregar artículos
                  </Button>
                )}
              </div>
            ) : (
              <div className="border border-slate-200 rounded overflow-hidden">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-slate-50">
                      <TableHead className="w-24">Código</TableHead>
                      <TableHead>Artículo</TableHead>
                      <TableHead className="text-center w-20">Cantidad</TableHead>
                      <TableHead className="text-right w-25">Precio Unit.</TableHead>
                      <TableHead className="text-right w-25">Total</TableHead>
                      {isEdit && <TableHead className="w-12"></TableHead>}
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {formData.items.map((item, index) => (
                      <TableRow key={index} className="table-row-hover">
                        <TableCell className="mono text-sm">{item.article_code}</TableCell>
                        <TableCell className="font-medium">{item.article_name}</TableCell>
                        <TableCell>
                          {isEdit ? (
                            <div className="flex items-center justify-center gap-1">
                              <Button
                                variant="outline"
                                size="icon"
                                className="h-8 w-8"
                                data-testid={`decrease-qty-${index}`}
                                onClick={() => handleUpdateQuantity(index, item.quantity - 1)}
                              >
                                <Minus size={14} />
                              </Button>
                              <Input
                                type="number"
                                value={item.quantity}
                                onChange={(e) =>
                                  handleUpdateQuantity(index, parseInt(e.target.value) || 1)
                                }
                                className="w-16 h-8 text-center mono"
                                data-testid={`quantity-input-${index}`}
                                min="1"
                              />
                              <Button
                                variant="outline"
                                size="icon"
                                className="h-8 w-8"
                                data-testid={`increase-qty-${index}`}
                                onClick={() => handleUpdateQuantity(index, item.quantity + 1)}
                              >
                                <Plus size={14} />
                              </Button>
                            </div>
                          ) : (
                            <span className="text-center block">{item.quantity}</span>
                          )}
                        </TableCell>
                        <TableCell className="text-right">

                          <span className="mono">{formatNumeric(item.unit_price)}</span>

                        </TableCell>
                        <TableCell className="text-right mono font-semibold">
                          {formatNumeric(item.total)}
                        </TableCell>
                        {isEdit && (
                          <TableCell>
                            <Button
                              variant="ghost"
                              size="icon"
                              data-testid={`remove-item-${index}`}
                              onClick={() => handleRemoveItem(index)}
                              className="h-8 w-8 text-red-600 hover:text-red-700 hover:bg-red-50"
                            >
                              <Trash2 size={16} />
                            </Button>
                            {item.impuesto}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>

          {/* Totals */}
          <div className="flex justify-end mb-6">
            <div className="w-72 space-y-2 bg-slate-50 p-4 rounded">
              <div className="flex justify-between text-sm">
                <span className="text-slate-500">Subtotal:</span>
                <span className="mono">{formatCurrency(subtotal)}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-500">ITBIS (18%):</span>
                <span className="mono">{formatCurrency(tax)}</span>
              </div>
              <div className="flex justify-between text-xl font-bold border-t border-slate-200 pt-2 mt-2">
                <span>Total:</span>
                <span className="mono text-blue-600" data-testid="document-total">
                  {formatCurrency(total)}
                </span>
              </div>
            </div>
          </div>

          {/* Comments */}
          <div className="space-y-2">
            <Label>Comentarios</Label>
            {isEdit ? (
              <Textarea
                data-testid="comments-input"
                value={formData.comments}
                onChange={(e) =>
                  setFormData({ ...formData, comments: e.target.value })
                }
                placeholder="Notas adicionales..."
                rows={3}
              />
            ) : (
              <p className="text-slate-600 bg-slate-50 p-3 rounded">
                {formData.comments || "Sin comentarios"}
              </p>
            )}
          </div>

          {/* Footer - Creator Info */}
          <div className="mt-6 pt-4 border-t border-slate-200 flex items-center justify-between text-sm text-slate-500">
            <div className="flex items-center gap-2">
              <User size={14} />
              <span>Creado por: <strong className="text-slate-700">{docInfo?.user_name || user?.name || "N/A"}</strong></span>
            </div>
            <div>
              <span className="text-xs">{user.company_name} - Portal de Ventas</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Search Modal */}
      <Dialog open={showArticleModal} onOpenChange={setShowArticleModal}>
        <DialogContent
          // className="sm:max-w-5xl max-h-[100vh] overflow-hidden flex flex-col"
          className="w-screen max-w-none h-screen m-0 rounded-none flex flex-col p-6 [&>button]:hidden"

        >
          <DialogHeader>
            <DialogTitle className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <Package size={20} />
                Buscar Artículos
              </span>
              <div className="flex items-center gap-4">
                {/* Badge de Precio */}
                <span className={`px-4 py-2 rounded-lg text-sm font-bold shadow-sm ${PRICE_TYPES[formData.priceType].color}`}>
                  Precio: {PRICE_TYPES[formData.priceType].label}
                </span>

                {/* BOTÓN DE CERRAR DESTACADO */}
                <Button
                  variant="destructive"
                  size="lg"
                  className="flex items-center gap-2 px-6 h-12 font-bold shadow-md hover:scale-105 transition-transform"
                  onClick={() => setShowArticleModal(false)}
                >
                  <X size={20} />
                  CERRAR (ESC)
                </Button>
              </div>
            </DialogTitle>

          </DialogHeader>

          {/* Search Input */}
          <div className="relative mb-4">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
            <Input
              data-testid="article-search-input"
              placeholder="Buscar por código, nombre o descripción..."
              value={articleSearch}
              onChange={(e) => {
                setCurrentPage(1);
                setArticleSearch(e.target.value)
              }}
              className="pl-10 h-11"
              autoFocus
            />
            {articleSearch && (
              <Button
                variant="ghost"
                size="icon"
                className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7"
                onClick={() => {
                  setCurrentPage(1);
                  setArticleSearch("")
                }}
              >
                <X size={14} />
              </Button>
            )}
          </div>

          {/* Articles Table */}
          <div className="flex-1 overflow-auto border border-slate-200 rounded" styles={{ Height: '100hv' }}>
            <Table>
              <TableHeader className="sticky top-0 bg-white z-10">
                <TableRow className="bg-slate-50">
                  <TableHead className="w-24">Código</TableHead>
                  <TableHead>Descripción</TableHead>
                  <TableHead className="text-right w-28">
                    <span className="text-blue-600">Consumo</span>
                  </TableHead>
                  <TableHead className="text-right w-28">
                    <span className="text-emerald-600">Mayor</span>
                  </TableHead>
                  <TableHead className="text-right w-28">
                    <span className="text-purple-600">Flotilla</span>
                  </TableHead>
                  <TableHead className="text-center w-16">Stock</TableHead>
                  <TableHead className="text-center w-24">Acción</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {articles.rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} className="text-center py-8 text-slate-500">
                      No se encontraron artículos
                    </TableCell>
                  </TableRow>
                ) : (
                  articles.rows.map((article) => {
                    const inCart = formData.items.find((i) => i.article_id === article.id);
                    const selectedPrice = getArticlePrice(article);
                    return (
                      <TableRow key={article.id} className="table-row-hover">
                        <TableCell className="mono font-medium text-sm">
                          {article.code}
                        </TableCell>
                        <TableCell>
                          <div>
                            <p className="font-medium text-slate-800">{article.name}</p>
                            <div className="flex items-center gap-2 mt-1">
                              <span className={`px-2 py-0.5 rounded text-xs font-medium ${getCategoryStyle(article.category)}`}>
                                {getCategoryLabel(article.category)}
                              </span>
                              {article.brand && (
                                <span className="text-xs text-slate-500">{article.brand}</span>
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell className={`text-right mono text-sm ${formData.priceType === 'retail' ? 'font-bold bg-blue-50' : ''}`}>
                          {formatNumeric(article.price)}
                        </TableCell>
                        <TableCell className={`text-right mono text-sm ${formData.priceType === 'wholesale' ? 'font-bold bg-emerald-50' : ''}`}>
                          {article.price_wholesale
                            ? formatNumeric(article.price_wholesale)
                            : "-"}
                        </TableCell>
                        <TableCell className={`text-right mono text-sm ${formData.priceType === 'fleet' ? 'font-bold bg-purple-50' : ''}`}>
                          {article.price_fleet
                            ? formatNumeric(article.price_fleet)
                            : "-"}
                        </TableCell>
                        <TableCell className="text-center">
                          <Popover>
                            <PopoverTrigger asChild>
                              <button
                                data-testid={`stock-popup-${article.id}`}
                                className={`px-2 py-1 rounded text-xs font-medium cursor-pointer hover:ring-2 hover:ring-offset-1 transition-all ${article.stock > 10
                                  ? "bg-emerald-100 text-emerald-700 hover:ring-emerald-300"
                                  : article.stock > 0
                                    ? "bg-amber-100 text-amber-700 hover:ring-amber-300"
                                    : "bg-red-100 text-red-700 hover:ring-red-300"
                                  }`}
                              >
                                {article.stock}
                              </button>
                            </PopoverTrigger>
                            <PopoverContent className="w-64 p-0" align="center">
                              <div className="p-2 border-b border-slate-200 bg-slate-50">
                                <div className="flex items-center gap-2">
                                  <Warehouse size={14} className="text-slate-500" />
                                  <span className="font-semibold text-slate-800 text-xs">Existencia por Almacén</span>
                                </div>
                              </div>
                              <div className="p-1">
                                {WAREHOUSES.map((wh) => {
                                  const qty = article.stock_almacenes.filter(e => e.alm === wh.almacen)[0]?.existencia || 0
                                  return (
                                    <div
                                      key={wh.key}
                                      className="flex items-center justify-between py-1.5 px-2 hover:bg-slate-50 rounded text-sm"
                                    >
                                      <div className="flex items-center gap-2">
                                        <div className={`w-2 h-2 rounded-full ${wh.color}`}></div>
                                        <span className="text-slate-600 text-xs">{wh.description}</span>
                                      </div>
                                      <span className={`font-semibold mono text-xs ${qty > 5 ? "text-emerald-600" : qty > 0 ? "text-amber-600" : "text-red-500"
                                        }`}>
                                        {qty}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="p-2 border-t border-slate-200 bg-slate-50 flex items-center justify-between">
                                <span className="text-xs font-medium text-slate-600">Total d:</span>
                                <span className="font-bold text-slate-800 mono text-xs">{article.stock}</span>
                              </div>
                            </PopoverContent>
                          </Popover>
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center justify-center gap-1">
                            <Button
                              size="sm"
                              data-testid={`add-article-${article.id}`}
                              onClick={() => handleAddArticle(article)}
                              className={`h-8 px-3 text-xs ${formData.priceType === 'retail' ? 'bg-blue-600 hover:bg-blue-700' :
                                formData.priceType === 'wholesale' ? 'bg-emerald-600 hover:bg-emerald-700' :
                                  'bg-purple-600 hover:bg-purple-700'
                                }`}
                            >
                              {inCart && (
                                <span className="ml-1 text-xs text-slate-500 bg-slate-100 px-2 py-1 rounded">
                                  x{inCart.quantity}
                                </span>
                              )}
                              <Plus size={14} className="mr-1" />

                            </Button>

                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </div>

          {/* Footer info */}
          <div className="mt-4 flex items-center justify-between text-sm">
            <span className="text-slate-500">{articles.rows.length} artículos encontrados</span>
            <div className="flex items-center gap-4">
              <span className="text-slate-500">{formData.items.length} artículos en el documento</span>
              <span className={`px-2 py-1 rounded text-xs font-medium ${PRICE_TYPES[formData.priceType].color}`}>
                Usando precio: {PRICE_TYPES[formData.priceType].label}
              </span>
            </div>
            {/* Pagination */}
            {/* {clients.totalPages > 1 && ( */}

            < div className="flex items-center justify-between mt-8 p-4 bg-white rounded-lg border border-slate-200">

              <div className="text-sm text-slate-500">
                Mostrando {((articles.page - 1) * articles.totalPages) + 1} - {articles.rows.length} de {articles.totalRow} clientes
              </div>
              <div className="flex items-center gap-1">
                {/* Previous Button */}
                <Button
                  variant="outline"
                  size="icon"
                  className="h-8 w-8"
                  onClick={() => handlePageChange(articles.page - 1)}
                  disabled={articles.page === 1}
                >
                  <ChevronLeft size={16} />
                </Button>

                {/* Page Numbers */}
                {(() => {
                  const pages = [];
                  const totalPages = articles.totalPages;
                  const currentPage = articles.page;

                  // Always show first page
                  pages.push(1);

                  // Calculate range around current page
                  let startPage = Math.max(2, currentPage - 1);
                  let endPage = Math.min(totalPages - 1, currentPage + 1);

                  // Add ellipsis after first page if needed
                  if (startPage > 2) {
                    pages.push('...');
                  }

                  // Add pages in range
                  for (let i = startPage; i <= endPage; i++) {
                    if (!pages.includes(i)) {
                      pages.push(i);
                    }
                  }

                  // Add ellipsis before last page if needed
                  if (endPage < totalPages - 1) {
                    pages.push('...');
                  }

                  // Always show last page if more than 1 page
                  if (totalPages > 1 && !pages.includes(totalPages)) {
                    pages.push(totalPages);
                  }

                  return pages.map((page, index) => (
                    page === '...' ? (
                      <span key={`ellipsis-${index}`} className="px-2 text-slate-400">...</span>
                    ) : (
                      <Button
                        key={page}
                        variant={currentPage === page ? "default" : "outline"}
                        size="icon"
                        className={`h-8 w-8 ${currentPage === page ? 'bg-[#0F172A] text-white' : ''}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </Button>
                    )
                  ));
                })()}

                {/* Next Button */}
                <Button
                  variant="outline"
                  size="icon"
                  className="h-8 w-8"
                  onClick={() => handlePageChange(articles.page + 1)}
                  disabled={!articles.page === articles.totalPages}
                >
                  <ChevronRight size={16} />
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Post-Save Actions Modal */}
      <AlertDialog open={showPostSaveModal} onOpenChange={setShowPostSaveModal}>
        <AlertDialogContent className="sm:max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2">
              <Check className="text-emerald-600" size={24} />
              ¡{docTypeLabels[formData.doc_type]} Guardado!
            </AlertDialogTitle>
            <AlertDialogDescription>
              El documento #{docInfo?.doc_number} ha sido guardado exitosamente.
              ¿Qué deseas hacer ahora?
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="space-y-4 py-4">
            {/* Send Email Section */}
            <div className="border border-slate-200 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <Mail size={18} className="text-blue-600" />
                <span className="font-medium text-slate-800">Enviar por Correo</span>
              </div>
              <div className="space-y-3">
                <Input
                  type="email"
                  placeholder="correo@cliente.com"
                  value={recipientEmail}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                  disabled={emailSent}
                />
                <Button
                  onClick={handleSendEmail}
                  disabled={sendingEmail || emailSent || !recipientEmail}
                  className="w-full bg-blue-600 hover:bg-blue-700"
                >
                  {emailSent ? (
                    <>
                      <Check size={16} className="mr-2" />
                      Correo Enviado
                    </>
                  ) : sendingEmail ? (
                    <>
                      <Send size={16} className="mr-2 animate-pulse" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <Send size={16} className="mr-2" />
                      Enviar Correo
                    </>
                  )}
                </Button>
              </div>
            </div>

            {/* Save/Share as Image Section */}
            <div className="border border-slate-200 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <Image size={18} className="text-emerald-600" />
                <span className="font-medium text-slate-800">Descargar Documento</span>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <Button
                  variant="outline"
                  onClick={handleSaveAsPDF}
                  className="flex-1 border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
                >
                  <FileText size={16} className="mr-2" />
                  PDF
                </Button>
                <Button
                  variant="outline"
                  onClick={handleSaveAsImage}
                  className="flex-1"
                >
                  <Download size={16} className="mr-2" />
                  Imagen
                </Button>
                {/* */}
                {<Button
                  variant="outline"
                  onClick={handlePrintPOS}
                  className="flex-1 border-emerald-200 text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700"
                  disabled={!window.ReactNativeWebView}
                >
                  <Printer size={16} className="mr-2" />
                  PrintPOS
                </Button>
                }
              </div>
            </div>
          </div>

          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => {
              setShowPostSaveModal(false);
              setEmailSent(false);
              setRecipientEmail("");
              setSaved(false)
            }}>
              Cerrar
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default DocumentEditorPage;
